import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_col = _resolveComponent("van-col");
  const _component_van_row = _resolveComponent("van-row");
  const _component_van_cell = _resolveComponent("van-cell");
  const _component_ListViewCpt = _resolveComponent("ListViewCpt");
  const _component_PageNavBackLayoutCpt = _resolveComponent("PageNavBackLayoutCpt");
  return _openBlock(), _createBlock(_component_PageNavBackLayoutCpt, {
    class: "synthetical-commission-page"
  }, {
    default: _withCtx(() => [_createVNode(_component_ListViewCpt, {
      ref: "ListViewCpt",
      request: $data.listRequest,
      requestParameter: $data.searchForm
    }, {
      default: _withCtx(({
        item
      }) => [_createVNode(_component_van_cell, {
        title: item.customerName + ' - ' + item.productName
      }, {
        label: _withCtx(() => [_createVNode(_component_van_row, {
          gutter: "20"
        }, {
          default: _withCtx(() => [_createVNode(_component_van_col, {
            span: "12"
          }, {
            default: _withCtx(() => [_createTextVNode("交易号码：" + _toDisplayString(item.tradeNo), 1)]),
            _: 2
          }, 1024), _createVNode(_component_van_col, {
            span: "12"
          }, {
            default: _withCtx(() => [_createTextVNode("成立时间: " + _toDisplayString(item.foundDate), 1)]),
            _: 2
          }, 1024)]),
          _: 2
        }, 1024), _createVNode(_component_van_row, {
          gutter: "20"
        }, {
          default: _withCtx(() => [_createVNode(_component_van_col, {
            span: "12"
          }, {
            default: _withCtx(() => [_createTextVNode("封闭期: " + _toDisplayString(item.closePeriod) + " " + _toDisplayString(_ctx.formatSelectColumn($data.codeResItems, 'closePeriodUnit', {
              closePeriodUnit: item.closePeriodUnit
            })), 1)]),
            _: 2
          }, 1024), _createVNode(_component_van_col, {
            span: "12"
          }, {
            default: _withCtx(() => [_createTextVNode("回访状态: " + _toDisplayString(_ctx.formatSelectColumn($data.codeResItems, 'callBackStatus', {
              callBackStatus: item.callBackStatus
            })), 1)]),
            _: 2
          }, 1024)]),
          _: 2
        }, 1024), _createVNode(_component_van_row, {
          gutter: "20"
        }, {
          default: _withCtx(() => [_createVNode(_component_van_col, {
            span: "12"
          }, {
            default: _withCtx(() => [_createTextVNode("认购费减免比例: " + _toDisplayString(item.reductionRadio), 1)]),
            _: 2
          }, 1024), _createVNode(_component_van_col, {
            span: "12"
          }, {
            default: _withCtx(() => [_createTextVNode("年化业务费率: " + _toDisplayString(item.commissionRate), 1)]),
            _: 2
          }, 1024)]),
          _: 2
        }, 1024), _createVNode(_component_van_row, {
          gutter: "20"
        }, {
          default: _withCtx(() => [_createVNode(_component_van_col, {
            span: "12"
          }, {
            default: _withCtx(() => [_createTextVNode("业务费率: " + _toDisplayString(item.discountCommissionRate), 1)]),
            _: 2
          }, 1024), _createVNode(_component_van_col, {
            span: "12"
          }, {
            default: _withCtx(() => [_createTextVNode("业务费: " + _toDisplayString(item.commission), 1)]),
            _: 2
          }, 1024)]),
          _: 2
        }, 1024)]),
        _: 2
      }, 1032, ["title"])]),
      _: 1
    }, 8, ["request", "requestParameter"])]),
    _: 1
  });
}